export const Role = {
  User: "User",
  Moderator: "Moderator",
  Admin: "Admin",
  MegaAdmin: "MegaAdmin",
};
